// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PaperSelector-cls1___99dc83ee55eb3da12ba{/*!*/}.PaperSelector-cls2__c5c38db8bc30a80e1f57{display:flex;flex-direction:column;grid-gap:16px;gap:16px;padding:24px 16px;margin:8px 0;background-color:#f8f8fb}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "PaperSelector-cls1___99dc83ee55eb3da12ba",
	"cls2": "PaperSelector-cls2__c5c38db8bc30a80e1f57 PaperSelector-cls1___99dc83ee55eb3da12ba"
};
export default ___CSS_LOADER_EXPORT___;
